"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchSettings = void 0;
const utils_1 = require("../../utils");
const getEnvVariables_1 = require("./getEnvVariables");
function getSearchSettings(req) {
    (0, utils_1.assertServerEnv)('getSearchSettings');
    // `getEnvVariables` handles both cases for envs parsing - .env and request headers
    const { ALGOLIA_API_KEY = '', ALGOLIA_APP_ID = 'UI4CNRAHQB', ALGOLIA_INDEX = 'public_stories_prod', MEILISEARCH_API_KEY, MEILISEARCH_HOST = 'https://search.prezly.com', MEILISEARCH_INDEX = 'public_stories', } = (0, getEnvVariables_1.getEnvVariables)(req);
    if (MEILISEARCH_API_KEY && MEILISEARCH_HOST && MEILISEARCH_INDEX) {
        return {
            apiKey: MEILISEARCH_API_KEY,
            host: MEILISEARCH_HOST,
            index: MEILISEARCH_INDEX,
            searchBackend: 'meilisearch',
        };
    }
    if (ALGOLIA_API_KEY && ALGOLIA_APP_ID && ALGOLIA_INDEX) {
        return {
            apiKey: ALGOLIA_API_KEY,
            appId: ALGOLIA_APP_ID,
            index: ALGOLIA_INDEX,
            searchBackend: 'algolia',
        };
    }
    return undefined;
}
exports.getSearchSettings = getSearchSettings;
//# sourceMappingURL=getSearchSettings.js.map